import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AnalyzeData,
  AnalyzedConsumption,
  Prediction,
  SmartScore
} from './analyse.types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnalyseService {
  hostUrl = 'https://appgw.prod.iktest.co/api-app/consumption';
  chemXUrl = 'https://appgw.prod.iktest.co/api-app/chemx';

  constructor(private _httpClient: HttpClient) {}

  getAnalyze(objectId: string): Observable<AnalyzedConsumption> {
    return this._httpClient.get<AnalyzedConsumption>(
      `${this.hostUrl}/analyze/${objectId}`
    );
  }

  getAnalyzePeriod(
    objectId: string,
    period: string
  ): Observable<AnalyzedConsumption> {
    return this._httpClient.get<AnalyzedConsumption>(
      `${this.hostUrl}/analyze/${objectId}/${period}`
    );
  }

  // NB: husk at analyze må kjøres for aktuell periode først for å få cachet opp timetabellene
  getAnalyzeData(
    objectId: string,
    period: string // YYYYMM or YYYYMMDD
  ): Observable<AnalyzeData> {
    return this._httpClient.get<AnalyzeData>(
      `${this.hostUrl}/analyzedata/${objectId}/${period}`
    );
  }

  getSmartScore(objectId: string): Observable<SmartScore> {
    return this._httpClient.get<SmartScore>(
      `${this.hostUrl}/smartscore/${objectId}`
    );
  }

  getSmartScorePeriod(
    objectId: string,
    period: string // YYYYMM
  ): Observable<SmartScore> {
    return this._httpClient.get<SmartScore>(
      `${this.hostUrl}/smartscore/${objectId}/${period}`
    );
  }

  getChemX(objectId: string): Observable<Prediction> {
    return this._httpClient.get<Prediction>(
      `${this.chemXUrl}/daymax/distribution/${objectId}`
    );
  }
}
